import React, { useEffect } from 'react';
import type { Role } from '@wix/ambassador-social-groups-v2-group-member-with-profile/types';

import { RoleIcon } from '../../RoleIcon';

import classes from './Comments.scss';

interface IProps {
  groupId: string;
  memberId: string;
  role?: Role;
  label?: string;
  releaseRole(groupId: string, memberId: string): unknown;
  fetchRole(groupId: string, memberId: string): unknown;
}

export function CommentAuthorRole({
  groupId,
  memberId,
  role,
  label,
  fetchRole,
  releaseRole,
}: IProps) {
  useEffect(() => {
    if (groupId && memberId && role === undefined) {
      fetchRole(groupId, memberId);
      return () => {
        releaseRole(groupId, memberId);
      };
    }
  }, [groupId, memberId, role, fetchRole, releaseRole]);

  return (
    <RoleIcon
      role={role}
      label={label}
      className={classes.authorRole}
      data-hook="comment-author-role"
    />
  );
}

CommentAuthorRole.displayName = 'CommentAuthorRole';
